import { useQuery } from "@tanstack/react-query";
import type { AxiosInstance } from "axios";
import type { LeaderboardQueryParams } from "@membentry/shared-types";
import { leaderboardQueryKey } from "./queryKeys";

/**
 * Fetch the leaderboard for a club.
 *
 * Wraps `GET /clubs/{clubId}/leaderboard`.
 */
export const useLeaderboardQuery = (
  client: AxiosInstance,
  params: LeaderboardQueryParams,
  options?: { enabled?: boolean },
) => {
  return useQuery({
    queryKey: leaderboardQueryKey(params),
    queryFn: async () => {
      const { getLeaderboard } = await import("@membentry/shared-api");
      return getLeaderboard(client, params);
    },
    enabled: options?.enabled !== false && params.clubId > 0,
  });
};
